import { ConciergeChatPageSkeleton, ConciergeFullPageSkeleton } from "@brandclub/bc-widgets";

/**
 * Pick a skeleton that resembles the destination route. Reloading
 * `/concierge?conversationId=…` (or a shared link) lands on a chat page, so
 * we should show the chat-shaped wireframe instead of the welcome/home one.
 *
 * URL inspection lives on the client; SSR falls back to the welcome
 * skeleton, which matches the route's most common state.
 */
const isChatPageUrl = (): boolean => {
  if (typeof window === "undefined") return false;
  const params = new URLSearchParams(window.location.search);
  return params.has("conversationId") || params.has("sharedConversationId");
};

const ConciergeFullScreenLoading = () =>
  isChatPageUrl() ? <ConciergeChatPageSkeleton /> : <ConciergeFullPageSkeleton />;

export default ConciergeFullScreenLoading;
